export default __webpack_public_path__ + "static/arrow-circle-43de8ebbf79d34f3f8afb8966727ab64.png";